import React from "react";
import { ReactComponent as NotificationEllipse } from "src/assets/icons/notification_ellipse.svg";

import "./notification-dot.scss";
import { getClassnames } from "src/utils/utils";

export const NOTIFICATION_DOT_VARIANT = {
  SINGLE: "single",
  TEXT: "text"
} as const;

export const NOTIFICATION_DOT_SIZE= {
  SMALL: "small",
  REGULAR: "regular"
} as any;

export type NotificationDotVariant =
  (typeof NOTIFICATION_DOT_VARIANT)[keyof typeof NOTIFICATION_DOT_VARIANT];

export type NotificationDotSize =
  (typeof NOTIFICATION_DOT_VARIANT)[keyof typeof NOTIFICATION_DOT_VARIANT];

export interface NotificationDotProps {
  variant?: NotificationDotVariant;
  size?: NotificationDotSize;
  show?: boolean;
  message?: string;
  className?: string;
}

export const NotificationDot = ({
  variant = NOTIFICATION_DOT_VARIANT.SINGLE,
  show,
  size = NOTIFICATION_DOT_SIZE.REGULAR,
  message,
  className,
}: NotificationDotProps) => {

  const containerClassName = getClassnames({
    [className]: !!className,
    ["notification-dot__container"]: true,
  });

  const dotClassNames = getClassnames({
    ["notification-dot__ellipse"]: true,
    ["notification-dot__ellipse__small"]: size === NOTIFICATION_DOT_SIZE.SMALL,
  });

  if (!show) {
    return null;
  }

  return (
    <div className={containerClassName}>
      {variant === NOTIFICATION_DOT_VARIANT.TEXT && (
        <div className="notification-dot__message pds-paragraph-m">
          {message}
        </div>
      )}
       {variant === NOTIFICATION_DOT_VARIANT.SINGLE && (
        <div className={dotClassNames}>
          <NotificationEllipse />
        </div>
       )}
    </div>
  );
};
